// All the following JS assumes you are using both jQuery and Shopify's option_selection.js

$(document).ready(function(){
  $('body').on('submit', "form.wishlist-form", function(e) {
    e.preventDefault();
    var formObj = $(this);
    var postData = $(this).serializeArray();
    var formURL = $(this).attr("action");
    var wishlistEl = $('#wishlist-page-link');
    var wishlistLink = wishlistEl.attr('href');
    var wishlistLabel = wishlistEl.html();

    $.ajax({
      url : formURL,
      type: "POST",
      data : postData,
      success:function(data, textStatus) {
          $.magnificPopup.open({
          removalDelay: 250,
          type: 'inline',
          items: {
            src: '<div id="wishlist-message-link" class="white-popup mfp-with-anim"><p>Added to your <a href="' + wishlistLink + '">' + wishlistLabel + '</a></p></div>',
            type: 'inline'
          },
          callbacks: {
            beforeOpen: function() {
              this.st.mainClass = 'mfp-zoom-out';
            },
            beforeClose: function() {
              $(this).find('iframe').addClass('animating-frame');
            }
          },
        });
        var clickedA = $(e.currentTarget);
        $(clickedA).find('.button-list').attr('data-tooltip', 'In Wishlist');
        formObj.parents('.js-wish-list-product').html('<p>This product is in your <a href="' + wishlistLink + '">' + wishlistLabel + '</a></p>');
            
      },
      error: function() {
        $(this).append("<p>I'm afraid that didn't work.</p>");
      }
    });
  });
});

function postToWishlist() {
  $("form[id^='wish-list-']").submit(function(e) {
    e.preventDefault();
    return;
    var formObj = $(this);
    var postData = $(this).serializeArray();
    var formURL = $(this).attr("action");
    $.ajax({
      url : formURL,
      type: "POST",
      data : postData,
      success:function(data, textStatus) {
        formObj.find('.js-wish-list').empty().html('<p>Success</p>');
      },
      error: function() {
        formObj.append("<p>I'm afraid that didn't work.</p>");
      }
    });
  });
}

function removeFromWishlist($this) {
  // select parent li element
  var $elem = $this.closest(".cart-row");
  // get the id which is the selected variant tag
  var tagID = $elem.attr("id");
  var $form = $("#contact_form");

  // set the value of the input in the form to the selected variant
  $("#remove-value").attr("value", tagID);
  var postData = $form.serialize();
  var formURL = $form.attr("action");

  $.ajax({
    url : formURL,
    type: "POST",
    data : postData,
    dataType: 'jsonp',
    success:function(data, textStatus) {
      $elem.remove();
      if($(".wishlist .cart-row").length == 0) {
        $("#wishlist-email-link").empty().html("<p>Your wish list is currently empty.</p>");
      } else {
        updateEmailList();
      }
    },
    error: function(jqXHR, textStatus, errorThrown) {
     // $(this).append("<p>I'm afraid that didn't work.</p>");
    }
  });
}

function updateEmailList() {
  var currentURL = window.location.protocol + "//" + window.location.host + window.location.pathname;
  $.ajax({
    url : currentURL,
    type: "GET",
    success:function(data, textStatus) {
      var newEmailLink = $(data).find("#wishlist-email-link a");
      $("#wishlist-email-link").html(newEmailLink);
    }
  });
}


// ======================================================
// remove from wishlist
// ======================================================
$(".js-remove-button").on("click", function(e) {
  e.preventDefault();
  removeFromWishlist($(this));
});

// ======================================================
// add to cart from wishlist
// ======================================================
$(".js-add-to-cart").on("click", function(e) {
  e.preventDefault();
  variantID = $(this).attr("data-id");
  $('#product-select').attr("value", variantID);
  // uncomment next line if you want a product to be removed from the wish list when it is added to the cart
  //removeFromWishlist($(this));
  $('#add-variant').submit();
});
